import {
  REGISTER_DO_REGISTER_BEGIN,
  REGISTER_DO_REGISTER_SUCCESS,
  REGISTER_DO_REGISTER_FAILURE,
  REGISTER_DO_REGISTER_DISMISS_ERROR,
} from './constants';

import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function doRegister(user,person,company,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: REGISTER_DO_REGISTER_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.

      //Creamos primero la persona
      return axios.post(SERVER_PATH + '/persons/create', {
        person:person,
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          //Si la persona se ha creado correctamente.
          if(res.data.success)
          {
            user.person = res.data.persons.insertId;
            /**************CREAR EL USUARIO************* */
            return axios.post(SERVER_PATH + '/users/normal/register', {
              user:user,
              company:company
            }, AXIOS_CONFIG)
            .then(
              (response) => {
                //Si usuario se ha creado correctamente.
                if(response.data.success === 1)
                {
                  response.data.username = user.username;
                  dispatch({
                    type: REGISTER_DO_REGISTER_SUCCESS,
                    data: response.data,
                  });
                  resolve(response);
                }else{
                  //Fallo al crear la usuario!
                  dispatch({
                    type: REGISTER_DO_REGISTER_FAILURE,
                      data: { error: response.data.message},
                  });
                  reject(response);
                }
              },
              // Use rejectHandler as the second argument so that render errors won't be caught.
              (err) => {
                dispatch({
                  type: REGISTER_DO_REGISTER_FAILURE,
                  data: { error: err },
                });
                reject(err);
              },
            );
            /***********TERMINA CREAR EL USUARIO******** */
          }else{
            //Fallo al crear la persona!
            dispatch({
              type: REGISTER_DO_REGISTER_FAILURE,
                data: { error: "No se pudo crear el usuario!" },
            });
            reject("No se pudo crear el usuario");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: REGISTER_DO_REGISTER_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}




// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissDoRegisterError() {
  return {
    type: REGISTER_DO_REGISTER_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REGISTER_DO_REGISTER_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        doRegisterPending: true,
        doRegisterError: null,
      };

    case REGISTER_DO_REGISTER_SUCCESS:
      let logged = action.data.success===1?true:false;
      // The request is success
      // The request is success
      if(logged)
      {
        localStorage.setItem("logged", logged);
        localStorage.setItem("username", action.data.username);
        localStorage.setItem("user_token", action.data.users.token);
        localStorage.setItem("user_id", action.data.users.user);
        localStorage.setItem("role", action.data.users.role);
        localStorage.setItem("avatar",action.data.users.avatar);
      } 
      return {
        ...state,
        logged: logged,
        openAlert: !logged,
        doRegisterPending: false,
        doRegisterError: null,
      };

    case REGISTER_DO_REGISTER_FAILURE:
      // The request is failed
      return {
        ...state,
        AlertaMessage:action.data.error,
        doRegisterPending: false,
        doRegisterError: action.data.error,
      };

    case REGISTER_DO_REGISTER_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        doRegisterError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/register/redux/doRegister.js